export default __webpack_public_path__ + "static/media/Rectangle.2825584f.png";